import config from 'cio/config/environment';
import { OAuthProvider, Provider } from 'cio/utils/oauth';

export default class SlackOauth extends OAuthProvider {
  name = Provider.Slack;
  baseUrl = 'https://slack.com/oauth/v2/authorize';
  clientId = config.oAuth.slack.apiKey;
  scope = 'channels:read,chat:write,chat:write.public,incoming-webhook,users:read';
  extraParams = {};

  protected get redirectUri() {
    return `${window.location.origin}/torii/redirect.html`;
  }
}
